import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { PageTitle } from '../../../_metronic/layout/core';
import { LogsTimeline } from '../../modules/logs';
import { retrieveDistributor } from '../../modules/distributors/services/DistributorCRUD';
import { DistributorModel } from '../../modules/distributors/models/DistributorModel';

type RouteParams = {
  distributorId: string;
};

const DistributorLogsPage: FC = () => {
  const intl = useIntl();
  const { distributorId } = useParams<RouteParams>();
  const [distributor, setDistributor] = useState<DistributorModel | null>(null);

  useEffect(() => {
    async function fetchDistributor() {
      try {
        const { data } = await retrieveDistributor(Number(distributorId));
        setDistributor(data);
      } catch (error) {
        console.warn(error);
      }
    }
    if (distributorId) {
      fetchDistributor();
    }
  }, [distributorId]);

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'logs.title' })}
      </PageTitle>
      <LogsTimeline
        kind="distributor"
        id={Number(distributorId)}
        entityName={distributor?.name}
      />
    </>
  );
};

export { DistributorLogsPage };
